import { UserInterfaceIdiomProvider } from '@psl/appComponents/UserInterfaceIdiomContext';
import { NavigatorScreenParams } from '@react-navigation/native';
import { lazy } from 'react';
import {
  adaptiveWrapperOptions,
  ModalWrapper,
} from '../../appComponents/ModalWrapper';
import { useIsMobileLayout } from '../../components/styles/responsive';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';
import type { ScheduleUpcomingShowScreensParams } from './components/ScheduleUpcomingShowFlowContent';

const ScheduleUpcomingShowFlowContent = lazy(
  () => import('./components/ScheduleUpcomingShowFlowContent'),
);

const ScheduleUpcomingShowFlow = wrapLazyNavigatorScreen(
  (_: NavigatorScreenParams<ScheduleUpcomingShowScreensParams> | {}) => {
    const isMobileLayout = useIsMobileLayout();
    if (isMobileLayout) {
      return (
        <UserInterfaceIdiomProvider
          name="schedule-show"
          userInterfaceStyle="light"
        >
          <ScheduleUpcomingShowFlowContent />
        </UserInterfaceIdiomProvider>
      );
    }
    return (
      <UserInterfaceIdiomProvider
        name="schedule-show"
        userInterfaceStyle="light"
      >
        <ModalWrapper withDropdownBounds={true}>
          <ScheduleUpcomingShowFlowContent />
        </ModalWrapper>
      </UserInterfaceIdiomProvider>
    );
  },
  adaptiveWrapperOptions(),
);

export default ScheduleUpcomingShowFlow;
